import { __assign, __read, __spreadArray } from "tslib";
import React, { createContext, useContext, useMemo, } from 'react';
import invariant from 'invariant';
import { useVelocityContext } from '../VelocityContext/VelocityContext';
import { GoogleMapsService } from '../../google/GoogleMapsService/GoogleMapsService';
var context = createContext(undefined);
export var GoogleMapsContextProvider = function (_a) {
    var children = _a.children, apiKey = _a.apiKey, _b = _a.libraries, libraries = _b === void 0 ? ['places', 'geometry'] : _b;
    var locale = useVelocityContext().locale;
    var language = locale.slice(0, 2);
    var value = useMemo(function () {
        return new GoogleMapsService({
            apiKey: apiKey,
            language: language,
            libraries: libraries,
        });
    }, __spreadArray([apiKey, language], __read(libraries /* keep a spread! */)));
    return React.createElement(context.Provider, { value: value }, children);
};
export var GoogleMapsContextConsumer = context.Consumer;
export var useGoogleMapsService = function () {
    var ctx = useContext(context);
    invariant(ctx !== undefined, 'GoogleMapsContext not found. Did you forget to put the GoogleMapsContextProvider?');
    return ctx;
};
export var withGoogleMapsService = function (Component) {
    return function (props) {
        var googleCtx = useGoogleMapsService();
        return (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        React.createElement(Component, __assign({}, props, { googleMapsService: googleCtx })));
    };
};
//# sourceMappingURL=GoogleMapsContext.js.map